import { Box, Button, ButtonProps, makeStyles } from "@material-ui/core";
import { MouseEventHandler } from "react";

export default function CustomButton({
  label = "Submit",
  variant = "outlined",
  style = {},
  onClick,
  ...props
}: ButtonProps & {
  label: string;
  onClick: MouseEventHandler<HTMLButtonElement>;
}): JSX.Element {
  const backgroundColor = variant === "outlined" ? "#fff" : "#0072BC";
  const color = variant === "outlined" ? "#0072BC" : "#fff";
  const borderColor = variant === "outlined" ? "#0072BC" : "inherit";

  const classes = useStyles();

  return (
    <Button
      className={classes.customButton}
      style={{
        backgroundColor,
        color,
        borderColor,
        ...style,
      }}
      variant={variant}
      onClick={onClick}
      {...props}
    >
      {label}
    </Button>
  );
}
const useStyles = makeStyles({
  customButton: {
    borderRadius: "3px",
    display: "block",
    width: "100%",
    margin: "36px 48px 36px 48px",
    padding: "10px 16px",
    boxShadow: "none",
    textTransform: "unset",
    fontSize: "18px",
    fontFamily: "OpenSans-SemiBold",
    maxWidth: "500px",
    "&:disabled": {
      backgroundColor: "lightgray",
      color: "#aaa",
      cursor: "not-allowed",
      opacity: 0.7,
      pointerEvents: "none",
    },
  },
});
